<template>
  <div>
    <div class="gt-md">
      <q-btn
        v-for="(item, index) in items"
        :key="index"
        :icon="item.icon"
        @click="item.action"
        v-if="isUser || !item.restricted"
        class="text-grey-8 q-mr-sm"
        flat
        :dense="item.icon !== undefined"
      >
        <template v-if="item.icon === undefined">
          {{ $t(item.text )}}
        </template>

        <q-tooltip v-else>
          {{ $t(item.text) }}
        </q-tooltip>
      </q-btn>
    </div>
    <div class="lt-lg">
      <q-btn flat icon="more_vert">
        <q-popover>
          <q-list link>
            <q-item
              v-for="item in items"
              :key="item.text"
              v-if="isUser || !item.restricted"
              class="text-grey-8"
              v-close-overlay
              @click.native="item.action"
            >
              <q-item-side left :icon="item.icon"/>
              <q-item-main>
                <span>{{ $t(item.text) }}</span>
              </q-item-main>
            </q-item>
          </q-list>
        </q-popover>
      </q-btn>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    props: {
      items: {
        type: Array,
        required: true
      }
    },

    computed: {
      ...mapGetters(['user']),

      isUser () {
        return this.user.isUserOfActiveTeam()
      }
    }
  }
</script>
